<template>
  <div class="form-group">
    <label class="form-label">Что именно произошло (дополнительные комментарии к событию)*</label>
    <textarea v-model="comments" name="comments" class="form-textarea" rows="6" placeholder="Указать в комментариях точный диагноз по справке от врача, локализацию и характер перелома либо площадь и степень ожога"></textarea>
    <p
        v-for="(error, index) of v$.comments.$errors"
        :key="index"
    ><strong class="error-message">{{error.$message}}</strong></p>
  </div>
</template>

<script>
import * as mns from "@/store/mutation-types";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";

export default {
  anotherNameLife: "RequiredTextarea",
  data(){
    return {
      v$: useVuelidate()
    };
  },
  validations(){
    return {
      comments: {
        required: helpers.withMessage('Поле должно быть заполнено', required),
      }
    }
  },
  computed: {
    comments: {
      get(){
        return this.$store.getters.comments;
      },
      set(value){
        this.$store.commit(mns.SET_COMMENTS, value);
      }
    }
  }
}
</script>

<style scoped>

</style>